import React, { useContext } from 'react';
import { AccordionItem, Accordion } from '@sm/wds-react';
import LogInCTA from '../../components/LogInCTA';
import SignUpCTA from '../../components/SignUpCTA';
import { MobileScreen } from '../../../..';

import { PlansAndPricingMenu } from './PlansAndPricingMenu';
import { HelpCenterMenu } from './HelpCenterMenu';
import { ProductsMenu } from './ProductsMenu';
import { SolutionsMenu } from './SolutionsMenu';
import { ResourcesMenu } from './ResourcesMenu';

import { MenusWithoutSubMenu } from './components/MenusWithoutSubMenu';

import SMHeaderContext from '../../SMHeaderContext.js';

import { showBlog } from '../../../../helpers/languageHelpers';

import './mobile-menu-anon.scss';

import {
  productsMenu,
  solutionsMenu,
  resourcesMenu,
} from '../../config/linkInfo.js';

export const MobileAnon = () => {
  const { lang } = useContext(SMHeaderContext);
  return (
    <>
      <Accordion
        noRules
        interactive
        className="sm-mobile-menu-anon"
        data-testid="MobileMenuAnon"
      >
        <AccordionItem title={productsMenu().title}>
          <ProductsMenu />
        </AccordionItem>

        <AccordionItem title={solutionsMenu().title}>
          <SolutionsMenu />
        </AccordionItem>
        {showBlog(lang) ? (
          <AccordionItem title={resourcesMenu().title}>
            <ResourcesMenu />
          </AccordionItem>
        ) : null}
      </Accordion>

      <MenusWithoutSubMenu>
        {!showBlog(lang) ? <HelpCenterMenu /> : null}
        <PlansAndPricingMenu />
      </MenusWithoutSubMenu>

      <MobileScreen>
        <div className="sm-mobile-menu-anon">
          <SignUpCTA
            size="md"
            variant="solid"
            color="upgrade"
            stretched
            className="sm-mobile-menu-anon__cta"
          />
          <LogInCTA
            size="md"
            variant="solid"
            color="primary"
            stretched
            className="sm-mobile-menu-anon__cta"
          />
        </div>
      </MobileScreen>
    </>
  );
};

export default MobileAnon;
